export default class Egtinfo {
    constructor() {
    /** @type {string}  */
        this.sektion = null;

        /** @type {string}   */
        this.parzellennummer = null;

        /** @type {string}   */
        this.egtinfotext = null;
    }
}
